import { MultiSelect } from "@/components/atoms";
import type { MetricSelectorProps } from "./types";

export function MetricSelector({ selectedIds, metrics, onChange, emptyMessage, isLoading, required, dynamicIds, onToggleDynamic }: MetricSelectorProps) {
    const uniqueMetrics = Array.from(
        new Map(
            metrics.map((metric) => [(metric.showName ?? "").toLowerCase(), metric] as const)
        ).values()
    );

    return (
        <MultiSelect
            label="Metrics"
            options={uniqueMetrics.map((metric) => ({
                id: metric.id,
                label: metric.showName,
                category: metric.category,
            })).sort((a, b) => a.label.localeCompare(b.label))}
            selectedIds={selectedIds}
            onChange={onChange}
            placeholder="Select one or more metrics"
            emptyMessage={emptyMessage || "No metrics available"}
            isLoading={isLoading}
            required={required}
            searchable
            markedIds={dynamicIds}
            onToggleMarked={onToggleDynamic}
            markPopoverTitle="Hide metric by default"
            markPopoverDescription="Only applies to table widgets. The metric will be hidden when the table loads; viewers can reveal it from the Columns dropdown."
            markActiveLabel="Show by default"
            markInactiveLabel="Hide by default"
        />
    );
}
